module.exports = __webpack_public_path__ + "static/media/1014375.5e01b109.jpg";